import { render } from "./TagSettings.vue?vue&type=template&id=40f1a7a4&scoped=true"
import script from "./TagSettings.vue?vue&type=script&lang=js"
export * from "./TagSettings.vue?vue&type=script&lang=js"

import "./TagSettings.vue?vue&type=style&index=0&id=40f1a7a4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40f1a7a4"]])

export default __exports__